import { createIcon } from '@chakra-ui/icons';

export const QuestionCircle = createIcon({
  displayName: 'QuestionCircle',
  viewBox: '0 0 18 18',
  path: [
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_554_3111)">
        <path
          d="M9 16.5586C13.1421 16.5586 16.5 13.2007 16.5 9.05859C16.5 4.91646 13.1421 1.55859 9 1.55859C4.85786 1.55859 1.5 4.91646 1.5 9.05859C1.5 13.2007 4.85786 16.5586 9 16.5586Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.00293 14.0586C9.55521 14.0586 10.0029 13.6109 10.0029 13.0586C10.0029 12.5063 9.55521 12.0586 9.00293 12.0586C8.45065 12.0586 8.00293 12.5063 8.00293 13.0586C8.00293 13.6109 8.45065 14.0586 9.00293 14.0586Z"
          fill="currentColor"
        />
        <path
          d="M7.5 4.95591C8.453 4.09591 10.518 4.11091 10.923 5.59091C11.453 7.51291 9 7.52091 9 10.3789"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_554_3111">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
